

/** 
  All of the routes for the Soft UI Dashboard React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/


// Soft UI Dashboard React layouts
import Dashboard from "layouts/dashboard";
import Tables from "layouts/tables";
import Billing from "layouts/billing";
import VirtualReality from "layouts/virtual-reality";
import RTL from "layouts/rtl";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import ForgotPassword from "layouts/authentication/forgot-password";
// import DownloadCode from "layouts/Features/DownloadQrCode/DownloadCode";
import ActivatePhysicalSim from "layouts/Features/ActivatePhysicalSim";
import ActivateESim from "layouts/Features/ActivateESim";
import NbnHomePage from "layouts/nbn/homepage"
import SearchAndAllocateSimStock from "layouts/Features/SearchAndAllocateSimStock";
import PidRegistration from "layouts/Features/PidRegistration";
import NonPidRegistration from "layouts/Features/NonPidRegistration";
import SearchAndAllocateReachargeVoucher from "layouts/Features/SearchAndAllocateReachargeVoucher";
import SearchStore from "layouts/Features/SearchStore";
import UploadDealerAgreement from "layouts/Features/UploadDealerAgreement";
import SellPhysicalRechargeVouchers from "layouts/Features/SellPhysicalRechargeVouchers";
import OrderFreeSimStock from "layouts/Features/OrderFreeSimStock";
import CartSection from "layouts/Features/SellPhysicalRechargeVouchers/Components/CartSection";
import OrderConfirmation from "layouts/Features/SellPhysicalRechargeVouchers/Components/ OrderConfirmation";
import SearchScreen from "layouts/Features/SellPhysicalRechargeVouchers/Components/SearchScreen";
import OrderFreeStock from "layouts/Features/OrderFreeStock";
import OfsCartSection from "layouts/Features/OrderFreeStock/Components/CartSection";




import FreeAccessoriesStockAllocation from "layouts/Features/FreeAccessoriesStockAllocation ";
import AddMobilePlan from "layouts/Features/AddMobilePlan";
import InternationalEsim from "layouts/Features/InternationalEsim";

import PrepaidActivation from "layouts/Features/PrepaidActivation";

import PrepaidRecharge from "layouts/Features/PrepaidRecharge";
import PurchasePhysicalRechargeVouchers from "layouts/Features/PurchasePhysicalRechargeVouchers";
import CreateWorkPlan from "layouts/Features/CreateWorkPlan";
import EsimSupportingDevices from "layouts/Features/EsimSupportngDevices";
import TelsimStockRequest from "layouts/Features/TelsimStockRequest";
import PremiumNumbers from "layouts/Features/PremiumNumbers";
import ReferAndEarn from "layouts/Features/ReferAndEarn";
import SearchAndAllocatePostPaidSimStock from "layouts/Features/SearchAndAllocatePostpaidSimStock";
import PostPaidActivation from "layouts/Features/PostPaidActivation";
import DownloadeSimQrCode from "layouts/Features/PostPaid/DownloadeSIMQrcode";
import PostPaidSimReplacement from "layouts/Features/PostPaid/PostPaidSimReplacement";

import CommonDownloadQrCode from "layouts/Features/CommonDownloadQrCode";
import CommonSIMReplacement from "layouts/Features/CommonSIMReplacement"
import SearchAndReturnSimStock from "layouts/Features/SearchAndReturnSimStock";


// Soft UI Dashboard React icons
import Shop from "examples/Icons/Shop";
import Office from "examples/Icons/Office";
import Settings from "examples/Icons/Settings";
import Document from "examples/Icons/Document";
import SpaceShip from "examples/Icons/SpaceShip";
import CustomerSupport from "examples/Icons/CustomerSupport";
import CreditCard from "examples/Icons/CreditCard";
import Cube from "examples/Icons/Cube";
import Basket from "examples/Icons/Basket";
import DownloadIcon from "examples/Icons/DownloadIcon";
import SimIcon from "examples/Icons/SimIcon";
import Arrow from "examples/Icons/Arrow";
import Money from "examples/Icons/Arrow";


const routes = [
  {
    type: "collapse",
    name: "Order NBN Service",
    key: "prepaid_Recharge",
    route: "/prepaid_mobile_recharge",
    icon: <Office size="12px" />,
    component: <PrepaidRecharge/>,
    noCollapse: true,
    protected: true,
  },

  // {
  //   type: "collapse",
  //   name: "Order NBN Service",
  //   key: "post_paid_activation",
  //   route: "/post_paid_activation",
  //   icon: <Office size="12px" />,
  //   component: <PostPaidActivation/>,
  //   noCollapse: true,
  //   protected: true,
  // },

  {
    type: "collapse",
    name: "Order NBN Service ",
    key: "nbn_purchase",
    route: "/nbn_purchase",
    icon: <Office size="12px" />,
    component: <NbnHomePage />,
    noCollapse: true,
    protected: true,
  },

  {
    type: "collapse",
    name: "Dealer Agreement",
    key: "upload-agreement",
    route: "/upload-agreement",
    icon: <Cube size="12px" />,
    component: <UploadDealerAgreement />,
    noCollapse: true,
    protected: true,
  },

  {
    type: "collapse",
    name: "TS Prepaid Recharge Voucher",
    key: "sell_physical_recharge_vouchers",
    route: "/sell_physical_recharge_vouchers",
    icon: <Arrow size="10px" />,
    component: <SellPhysicalRechargeVouchers />,
    noCollapse: true,
  },

  {
    type: "collapse",
    name: "Non PID Registration",
    key: "non-pid-registration",
    route: "/non-pid-registration",
    icon: <Office size="12px" />,
    component: <NonPidRegistration/>,
    noCollapse: true,
  
  },

  {
    type: "collapse",
    name: "Search And Allocate Sim Stock",
    key: "allocate-sim-stock",
    route: "/allocate-sim-stock",
    icon: <Office size="12px" />,
    component: <SearchAndAllocateSimStock/>,
    noCollapse: true,
    protected:true,
    protected: true,
  },

  {
    type: "collapse",
    name: "Retail Stores",
    key: "search_store",
    route: "/search_store",
    icon: <Arrow size="10px" />,
    component: <SearchStore />,
    noCollapse: true,
    protected: true,
  },

  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    route: "/dashboard",
    icon: <Shop size="12px" />,
    component: <Dashboard />,
    noCollapse: true,
    protected: true,
  },
  
 
  {
    type: "collapse",
    name: "Sell Physical Recharge Vouchers",
    key: "sell_physical_recharge_vouchers",
    route: "/sell_physical_recharge_vouchers",
    icon: <Shop size="12px" />,
    component: <SellPhysicalRechargeVouchers/>,
    noCollapse: true,
    protected: true,
  },

  {
    type: "collapse",
    name: "Registrations",
    key: "registrations",
    icon: <Shop size="12px" />,
    children:[
        {
          type: "collapse",
          name: "PID-Registration",
          key: "pid-registration",
          route: "/pid-registration",
          icon: <Office size="12px" />,
          component: < PidRegistration/>,
          noCollapse: true,
          
        },
        {
          type: "collapse",
          name: "NON-PID-Registration",
          key: "non-pid-registration",
          route: "/non-pid-registration",
          icon: <Office size="12px" />,
          component: <NonPidRegistration/>,
          noCollapse: true,
        
        },
    ]
  },




  {
    type: "collapse",
    name: "Telsim Prepaid Mobile",
    key: "telsim_prepaid_mobile",
    icon: <Office size="12px" />,
    
    children: [

      {
        type: "collapse",
        name: "Activate Prepaid Plan",
        key: "activate_prepaid_plan",
        icon: <CreditCard size="12px" />,
        route: "/activate_prepaid_plan",
        noCollapse: true,
        protected: true,
        nochild:true
      },
      {
        type: "collapse",
        name: "Activate ME Prepaid Plan",
        key: "activate_prepaid_plan_me",
        icon: <CreditCard size="12px" />,
        route: "/activate_prepaid_plan_me",
        noCollapse: true,
        protected: true,
        nochild:true
      },
      {
        type: "collapse",
        name: "Activate Postpaid Plan",
        key: "post_paid_activation",
        icon: <CreditCard size="12px" />,
        component: <PostPaidActivation/>,
        route:"/post_paid_activation",
        noCollapse: true,
        protected: true,
        nochild:true
      },
      // {
      //   type: "collapse",
      //   name: "Activate Premium Number",
      //   key: "premium_numbers",
      //   route: "/premium_numbers",
      //   icon: <Arrow size="12px" />,
      //   component: <PremiumNumbers/>,
      //   noCollapse: true,
      //   protected: true,
      //   nochild:true
      // },
      {
        type: "collapse",
        name: "Add a Prepaid Plan",
        key: "add_a_prepaid_plan",
        icon: <Money size="12px" />,
        route: "/add_a_prepaid_plan",
        noCollapse: true,
        protected: true,
        nochild:true
      },

      {
        type: "collapse",
        name: "Add a ME Prepaid Plan",
        key: "add_a_prepaid_plan_me",
        icon: <CreditCard size="12px" />,
        route: "/add_a_prepaid_plan_me",
        noCollapse: true,
        protected: true,
        nochild:true
      },

      {
        type: "collapse",
        name: "Recharge",
        key: "prepaid_mobile_recharge",
        icon: <SimIcon size="12px" color="#9c1554"  />,
        route: "/prepaid_mobile_recharge",
        noCollapse: true,
        protected: true,
        nochild:true
      },
      {
        type: "collapse",
        name: "Queue a Recharge",
        key: "recharge_voucher_queueing",
        icon: <Cube size="12px" />,
        route: "/recharge_voucher_queueing",
        noCollapse: true,
        protected: true,
        nochild:true
      },
      {
        type: "collapse",
        name: "Prepaid Plan Services",
        key: "prepaid_plan_services",
        icon: <SimIcon size="12px" color="#9c1554" />,
        noCollapse: true,
        protected: true,
        nochild:false,
        children: [
          {
            type: "collapse",
            name: "Register Telsim My Account",
            key: "register_telsim_myaccount",
            icon: <Arrow size="12px" />,
            route: "/register_telsim_myaccount",
            noCollapse: true,
            protected: true,
            nochild:true
          },
          // {
          //   type: "collapse",
          //   name: "Download eSIM QR Code",
          //   key: "download_esim_qr_code",
          //   icon: <Arrow size="12px" />,
          //   route: "/download_esim_qr_code",
          //   noCollapse: true,
          //   protected: true,
          //   nochild:true
          // },
          // {
          //   type: "collapse",
          //   name: "SIM Replacement",
          //   key: "sim_replacement_request",
          //   icon: <Arrow size="12px" />,
          //   route: "/sim_replacement_request",
          //   noCollapse: true,
          //   protected: true,
          //   nochild:true
          // },
        ]
      },
    ]
  },

  //post paid
  {
    type: "collapse",
    name: "Telsim SIM Only Mobile",
    key: "telsim_postpaid_mobile",
    icon: <Office size="12px" />,
    
    children: [

      {
        type: "collapse",
        name: "Activate SIM Only Plan",
        key: "sim_only_activation",
        icon: <CreditCard size="12px" />,
        route: "/sim_only_activation",
        component: <PostPaidActivation/>,
        noCollapse: true,
        protected: true,
        nochild:true
      },
      {
        type: "collapse",
        name: "SIM Only Plan Services",
        key: "postpaid_plan_services",
        icon: <SimIcon size="12px" color="#9c1554" />,
        noCollapse: true,
        protected: true,
        nochild:false,
        children: [
          {
            type: "collapse",
            name: "Download SIM Only eSIM QR Code",
            key: "download_esim_qr_code_sim_only",
            icon: <Arrow size="12px" />,
            route: "/download_esim_qr_code_sim_only",
            component: <DownloadeSimQrCode/>,
            noCollapse: true,
            protected: true,
            nochild:true
          },
          {
            type: "collapse",
            name: "SIM Only SIM Replacement",
            key: "sim_replacement_sim_only",
            icon: <Arrow size="12px" />,
            route: "/sim_replacement_sim_only",
            component: <PostPaidSimReplacement/>,
            noCollapse: true,
            protected: true,
            nochild:true
          },
        ]
      },
    ]
  },


  {
    type: "collapse",
    name: "Telsim SIM Services",
    key: "common_sim_services",
    icon: < Cube size="12px" />,
    children: [
      {
        type: "collapse",
        name: "Download  eSIM QR Code",
        key: "common_download_esim_qr_code",
        icon: <Arrow size="12px" />,
        route: "/common_download_esim_qr_code",
        component: <CommonDownloadQrCode/>,
        noCollapse: true,
        protected: true,
        nochild:true
      },
      {
        type: "collapse",
        name: "SIM Replacement",
        key: "common_sim_replacement",
        icon: <Arrow size="12px" />,
        route: "/common_sim_replacement",
        component: <CommonSIMReplacement/>,
        noCollapse: true,
        protected: true,
        nochild:true
      },
      {
        type: "collapse",
        name: "Register Telsim My Account",
        key: "common_register_myaccount",
        icon: <Arrow size="12px" />,
        route: "/common_register_myaccount",
        noCollapse: true,
        protected: true,
        nochild:true
      },
    ]
  },



  {
    type: "collapse",
    name: "Home Internet ",
    key: "home_internet",
    icon: <CustomerSupport size="12px" />,
    children: [
    {
      type: "collapse",
      name: "Order NBN Service ",
      key: "nbn_purchase",
      route: "/nbn_purchase",
      icon: <Arrow size="12px" />,
      component: <NbnHomePage />,
      noCollapse: true,
      protected: true,
      nochild:true
    },

    ]
  },
  
  {
    type: "collapse",
    name: "Travel eSIM",
    key: "travel_esim",
    component: <InternationalEsim />,
    icon: <SimIcon size="12px" color="primary" />,
    children: [
    {
      type: "collapse",
      name: "Activate Travel eSIM ",
      key: "activate_travel_esim",
      route: "/activate_travel_esim",
      icon: <Arrow size="12px" />,
      component: <InternationalEsim />,
      noCollapse: true,
      protected: true,
      nochild:true
    },
    {
      type: "collapse",
      name: "eSIM Supporting Devices ",
      key: "esim_supporting_devices",
      route: "/esim_supporting_devices",
      icon: <Arrow size="12px" />,
      component: <EsimSupportingDevices />,
      noCollapse: true,
      protected: true,
      nochild:true
    },
    ]
  },
  {
    type: "collapse",
    name: "Purchase",
    key: "purchase",
    icon: <CreditCard size="12px"   />,
    children: [
    {
      type: "collapse",
      name: "Prepaid Physical Recharge Voucher",
      key: "purchase_physical_recharge_voucher",
      route: "/purchase_physical_recharge_voucher",
      icon: <SimIcon size="12px" />,
      component: <PurchasePhysicalRechargeVouchers/>,
      noCollapse: true,
      protected: true,
      nochild:true
    },
    {
      type: "collapse",
      name: "Order SIM Stock",
      key: "order_sim_stocks",
      route: "/order_sim_stocks",
      icon: <SimIcon size="12px" />,
      component: <OrderFreeStock/>,
      noCollapse: true,
      protected: true,
      nochild:true
    },

    ]
  },



  {
    type: "collapse",
    name: "PID Services",
    key: "pid_services",
    icon: <Shop size="12px" />,
    children: [
      {
        type: "collapse",
        name: "Registration",
        key: "register",
        icon: <Settings size="12px" />,
        nochild:false,
        children: [
          {
            type: "collapse",
            name: "PID",
            key: "pid-registration",
            route: "/pid-registration",
            icon: <Arrow size="10px" />,
            component: < PidRegistration />,
            noCollapse: true,
            nochild:true
          },
          {
            type: "collapse",
            name: "Non PID",
            key: "non-pid-registration",
            route: "/non-pid-registration",
            icon: <Arrow size="10px" />,
            component: <NonPidRegistration />,
            noCollapse: true,
            nochild:true
          },

        ]

      },


      {
        type: "collapse",
        name: "File Uploads ",
        key: "file_upload",
        icon: <SpaceShip size="12px" />,
        nochild:false,
        children: [
          {
            type: "collapse",
            name: "Dealer Agreement",
            key: "upload-agreement",
            route: "/upload-agreement",
            icon: <Arrow size="12px" />,
            component: <UploadDealerAgreement />,
            noCollapse: true,
            protected: true,
            nochild:true
          },
        ]

      },

      {
        type: "collapse",
        name: "Free Stock Allocation",
        key: "free_stock",
        icon: <Basket size="12px" />,
        nochild:false,
        children: [
          {
            type: "collapse",
            name: "TS Allocate Physical SIM",
            key: "allocate_sim_stock_sim_only",
            route: "/allocate_sim_stock_sim_only",
            icon: <Arrow size="10px" />,
            component: <SearchAndAllocatePostPaidSimStock/>,
            noCollapse: true,
            protected: true,
            nochild:true
          },
          // {
          //   type: "collapse",
          //   name: "TS Prepaid Physical SIM ",
          //   key: "allocate-sim-stock",
          //   route: "/allocate-sim-stock",
          //   icon: <Arrow size="10px" />,
          //   component: <SearchAndAllocateSimStock />,
          //   noCollapse: true,
          //   protected: true,
          //   nochild:true
          // },
          {
            type: "collapse",
            name: "TS Prepaid Recharge Voucher",
            key: "allocate-recharge-voucher",
            route: "/allocate-recharge-voucher",
            icon: <Arrow size="10px" />,
            component: <SearchAndAllocateReachargeVoucher />,
            noCollapse: true,
            protected: true,
            nochild:true
          },
          {
            type: "collapse",
            name: "Accessories ",
            key: "free_accessories_stock_allocation",
            route: "/free_accessories_stock_allocation",
            icon: <Arrow size="10px" />,
            component: <FreeAccessoriesStockAllocation />,
            noCollapse: true,
            protected: true,
            nochild:true
          },

        ]

      },

      {
        type: "collapse",
        name: "Sales ",
        key: "sales",
        icon: <Office size="12px" />,
        nochild:false,
        children: [
          {
            type: "collapse",
            name: "TS Prepaid Recharge Voucher",
            key: "sell_physical_recharge_vouchers",
            route: "/sell_physical_recharge_vouchers",
            icon: <Arrow size="10px" />,
            component: <SellPhysicalRechargeVouchers />,
            noCollapse: true,
            protected: true,
            nochild:true
          },
        ]

      },

      {
        type: "collapse",
        name: "Search",
        key: "search_store_list",
        icon: < Cube size="12px" />,
        nochild:false,
        children: [
          {
            type: "collapse",
            name: "Retail Stores",
            key: "search_store",
            route: "/search_store",
            icon: <Arrow size="10px" />,
            component: <SearchStore />,
            noCollapse: true,
            protected: true,
            nochild:true
          }
        ]

      },
      {
        type: "collapse",
        name: "Work Plan",
        key: "work_plan",
        icon: < Cube size="12px" />,
        nochild:false,
        children: [
          {
            type: "collapse",
            name: "Create Work Plan",
            key: "create_work_plan",
            route: "/create_work_plan",
            icon: <Arrow size="10px" />,
            component: <CreateWorkPlan />,
            noCollapse: true,
            protected: true,
            nochild:true
          },
          {
            type: "collapse",
            name: "List My Work Plan",
            key: "list_my_work_plan",
            route: "/list_my_work_plan",
            icon: <Arrow size="10px" />,
            component: <CreateWorkPlan />,
            noCollapse: true,
            protected: true,
            nochild:true
          },
          {
            type: "collapse",
            name: "Approve Work Plan",
            key: "approve_work_plan",
            route: "/approve_work_plan",
            icon: <Arrow size="10px" />,
            component: <CreateWorkPlan />,
            noCollapse: true,
            protected: true,
            nochild:true
          },
          {
            type: "collapse",
            name: "Create Work Plan Deviation Request",
            key: "create_work_plan_deviation",
            route: "/create_work_plan_deviation",
            icon: <Arrow size="10px" />,
            component: <CreateWorkPlan />,
            noCollapse: true,
            protected: true,
            nochild:true
          },
          {
            type: "collapse",
            name: "List My Work Plan Deviation",
            key: "list_my_work_plan_deviation",
            route: "/list_my_work_plan_deviation",
            icon: <Arrow size="10px" />,
            component: <CreateWorkPlan />,
            noCollapse: true,
            protected: true,
            nochild:true
          },
          {
            type: "collapse",
            name: "Approval Work Plan Deviation",
            key: "approve_work_plan_deviation",
            route: "/approve_work_plan_deviation",
            icon: <Arrow size="10px" />,
            component: <CreateWorkPlan />,
            noCollapse: true,
            protected: true,
            nochild:true
          }
          ,
          {
            type: "collapse",
            name: "Update Daily Work",
            key: "update_my_daily_work",
            route: "/update_my_daily_work",
            icon: <Arrow size="10px" />,
            component: <CreateWorkPlan />,
            noCollapse: true,
            protected: true,
            nochild:true
          },
          {
            type: "collapse",
            name: "List My Daily Work",
            key: "list_my_daily_work",
            route: "/list_my_daily_work",
            icon: <Arrow size="10px" />,
            component: <CreateWorkPlan />,
            noCollapse: true,
            protected: true,
            nochild:true
          },
          {
            type: "collapse",
            name: "Approve Daily Work",
            key: "approve_daily_work",
            route: "/approve_daily_work",
            icon: <Arrow size="10px" />,
            component: <CreateWorkPlan />,
            noCollapse: true,
            protected: true,
            nochild:true
          }
        ]

      },

      {
        type: "collapse",
        name: "Stock Request",
        key: "telsim_stock_request",
        icon: < Cube size="12px" />,
        nochild:false,
        children: [
          {
            type: "collapse",
            name: "Stock Request",
            key: "stock_request",
            route: "/stock_request",
            icon: <Arrow size="10px" />,
            component: <TelsimStockRequest />,
            noCollapse: true,
            protected: true,
            nochild:true
          }
        ]

      },

      {
        type: "collapse",
        name: "Return Old Stock",
        key: "telsim_return_old_stock",
        icon: < Cube size="12px" />,
        nochild:false,
        children: [
          {
            type: "collapse",
            name: "Return Old SIM Stock",
            key: "return_old_sim_stock",
            route: "/return_old_sim_stock",
            icon: <Arrow size="10px" />,
            component: <SearchAndReturnSimStock />,
            noCollapse: true,
            protected: true,
            nochild:true
          }
        ]

      },
    ]
  },
]


export default routes;
